import { DeferredVideo } from './DeferredMedia';

const AwardsSchool = () => {
  return (
    <section className="awards_school">
      <div className="container">
        <div className="slider-video-content">
          <div className="slider-csi">
            <div className="video_imag_ctn">
              <DeferredVideo
                className="video"
                src="video/admission.mp4"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
              />
            </div>
            <div className="popup_design_op">
              <p>
                <strong>🌈🏫 Join the Rainbow family!</strong>
                <br></br>
                Admissions Open for a journey of knowledge, values, and success.
              </p>
            </div>
          </div>
          <div className="slider-csi">
            <div className="video_imag_ctn">
              <DeferredVideo
                className="video"
                src="video/award_video.mp4"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
              />
            </div>
            <div className="popup_design_op">
              <p>
                <strong>Congratulations!!!</strong>
                <br></br>
                Rainbow International School receives the "True Pioneer in Education " Award by Tribune Trust Himachal Achiever Award in Recognition for setting new benchmarks in Education.
                Principal, Dr. Chhavi Kashyap selected for the prestigious " Pioneer in Education awargd " for exceptional leadership and innovative contributions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsSchool;
